/**
 * 房源详情页 返回
 * 
 * @Author: Focci
 * @Date: 2023-10-17 16:08:37
 * @Last Modified by: Focci
 * @Last Modified time: 2023-10-17 16:08:37
 */

'use client'

import useProgressRouter from '@hook/useProgressRouter'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { ButtonBase } from '@comp/material'
import { useTranslations } from 'next-intl'
import clsx from 'clsx'

function RouteBackBody({ 
  label,
  className = 'bordder-none md:border-r pr-2 mr-2 text-c66'
}) {
  return (
    <div className={clsx(['flex items-center gap-x-0.5 cursor-pointer', className])}>
      <ArrowBackIcon sx={{ fontSize: '.9rem' }} />
      <div className="whitespace-nowrap max-w-[30vw] overflow-hidden">
        <span className="line-clamp-1">{label}</span>
      </div>
    </div>
  )
}

export default function RouteBack({
  className
}) {
  const tc = useTranslations('common')
  const { routerBack } = useProgressRouter()
  
  return (
    <ButtonBase onClick={routerBack}>
      <RouteBackBody label={tc('back')} className={className} />
    </ButtonBase>
  )
}
